

let initialUserData = null;
try {
  const storedUser = localStorage.getItem('userData');
  if (storedUser && storedUser !== 'undefined' && storedUser !== 'null') {
    initialUserData = JSON.parse(storedUser);
  }
} catch (e) {
  initialUserData = null;
}

const initialState = {
  userId: localStorage.getItem('userId') ?? null,
  userData: initialUserData,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_USER_ID':
      return {
        ...state,
        userId: action.payload,
      };
    case 'SAVE_USER_DATA':
      return {
        ...state,
        userData: action.payload,
      };
    case 'CLEAR_DATA':
      return {
        ...state,
        userId: null,
        userData: null,
      };
    default:
      return state;
  }
}
